export default __webpack_public_path__ + "static/media/banana4.858a6330.svg";